<script>
  import CategoryBarVis from '../CategoryBarVis.svelte';
  import Funfact from './Funfact.svelte';
  import ProductList from './ProductList.svelte';

  import { activeCountry, selectedProduct, funfacts } from '../../stores';
  import { isoLookup } from '../../utils';
  import { countryCol, funfactCol } from '../../config';

  const onClose = () => {
    activeCountry.set(null);
    selectedProduct.set(null);
  };

  $: currentFunFact = $funfacts.find(fun => fun[countryCol] === $activeCountry);
</script>

<style>
  .km-detailview {
    position: absolute;
    background: #fff;
    border: 1px solid #f3f3f3;
    box-shadow: 0 5px 20px -1px rgba(0, 0, 0, 0.06);
    border-radius: 5px !important;
    padding: 15px 20px;
    z-index: 2000;
    width: 100%;
  }

  .km-close {
    position: absolute;
    right: 8px;
    top: 8px;
    display: flex;
    line-height: 1;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #f3f3f3;
    border-radius: 50% !important;
    width: 24px;
    height: 24px;
    font-size: 20px;
    user-select: none;
  }

  .km-close:hover {
    opacity: 0.8;
  }

  .km-title {
    font-weight: 700;
    font-size: 20px;
    font-family: 'axiforma', Arial, sans-serif;
    margin-bottom: 10px;
  }

  @media screen and (min-width: 800px) {
    .km-detailview {
      bottom: 90px;
      left: 0px;
      width: 350px;
    }
  }
</style>

{#if $activeCountry}
  <div class="km-detailview">
    <div class="km-close" on:click={onClose}>×</div>
    <div class="km-title">{isoLookup[$activeCountry]}</div>
    <CategoryBarVis isoCode={$activeCountry} />

    {#if currentFunFact && currentFunFact[funfactCol]}
      <Funfact text={currentFunFact[funfactCol]} />
    {/if}

    <ProductList />
  </div>
{/if}
